import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAccountDetails } from './monthly-pension-account-details';

export class MonthlyPensionAccountActionResponse implements Deserializable {
  public warnings!: string[];
  public accountDetails!: MonthlyPensionAccountDetails;

  public onDeserialize(): void {
    this.accountDetails = window.injector.Deserialize.instanceOf(MonthlyPensionAccountDetails, this.accountDetails);
  }
}
